/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolInterestsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-interests"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M2.67 9.35L5.97 3.4Q6.17 3.05 6.47 2.89Q6.78 2.73 7.13 2.73Q7.47 2.73 7.78 2.89Q8.07 3.05 8.28 3.4L11.57 9.35Q11.78 9.7 11.76 10.05Q11.75 10.4 11.57 10.68Q11.4 10.95 11.1 11.14Q10.8 11.32 10.43 11.32L3.83 11.32Q3.45 11.32 3.15 11.14Q2.85 10.95 2.67 10.68Q2.5 10.4 2.49 10.05Q2.48 9.7 2.67 9.35ZM7.15 21.32Q7.15 21.32 6.25 21.32Q5.35 21.32 4.09 20.06Q2.83 18.8 2.83 17Q2.83 15.2 4.09 13.94Q5.35 12.68 7.15 12.68Q8.95 12.68 10.21 13.94Q11.47 15.2 11.47 17Q11.47 18.8 10.21 20.06Q8.95 21.32 7.15 21.32ZM12.8 20L12.8 14Q12.8 13.45 13.19 13.06Q13.57 12.68 14.13 12.68L20.13 12.68Q20.68 12.68 21.06 13.06Q21.45 13.45 21.45 14L21.45 20Q21.45 20.55 21.06 20.94Q20.68 21.32 20.13 21.32L14.13 21.32Q13.57 21.32 13.19 20.94Q12.8 20.55 12.8 20ZM16.27 10.6L15.07 9.6Q13.28 8.1 12.54 7.15Q11.8 6.2 11.8 5.08Q11.8 3.8 12.69 2.94Q13.57 2.08 14.88 2.08Q15.53 2.08 16.1 2.33Q16.68 2.58 17.13 3.08Q17.57 2.58 18.15 2.33Q18.73 2.08 19.38 2.08Q20.68 2.08 21.56 2.94Q22.45 3.8 22.45 5.08Q22.45 6.2 21.75 7.11Q21.05 8.03 19.23 9.55L17.98 10.6Q17.6 10.93 17.13 10.93Q16.65 10.93 16.27 10.6Z" fill={color} />
    </svg>
  );
}
